import React, { useState, useEffect } from 'react';

import { userActions, alertActions } from '../../actions';
import { history } from '../../helpers';

import { Link, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Login() {
  let query = useQuery();

  const [inputs, setInputs] = useState({
    username: '',
    password: ''
  });

  const { username, password } = inputs;
  const dispatch = useDispatch();

  useEffect(() => {
    if (query.get('confirmation')) {
      if (query.get('confirmation') === 'ok') {
        dispatch(alertActions.success({ userConfirmed: true }));
      } else if (query.get('confirmation') === 'ko') {
        dispatch(alertActions.error({ errors: { userConfirmed: false } }));
      }

      history.push('/login');
    }

    dispatch(userActions.logout());
    dispatch(userActions.clearRegistration());
    dispatch(userActions.clearReset());
  }, [dispatch, query]);

  function handleChange(e) {
    const { name, value } = e.target;
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (username && password) {
      dispatch(userActions.login(username, password));
    }
  }

  function isValidForm() {
    return username && password;
  }

  return (
    <div className="connexion-inscription">
      <div>
        <h2>Connexion</h2>
        <p>Accéder à votre espace personnel et vos réservations.</p>
        <form className="form form--login" noValidate onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Email</label>
            <input type="email" id="username" name="username" value={username} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input type="password" id="password" name="password" value={password} onChange={handleChange} />
          </div>
          <button disabled={!isValidForm()} className="btn btn--no-icon">Se connecter</button>
        </form>
        <p>
          <Link to="/reset" className="reset">Mot de passe oublié ?</Link>
        </p>
      </div>

      <div>
        <h2>Inscription</h2>
        <p>Pour effectuer votre réservation, <br></br>vous devez d'abord créer votre compte&nbsp;!</p>
        <Link to="/inscription" className="btn btn--no-icon">S'inscrire</Link>
      </div>
    </div>
  );
}

export default Login;
